import localforage from 'localforage';
import FirebaseStorage from "./firebase";
import Servo from "./servo";
import moment from "moment";

// Initialize the store
localforage.config({
  name: 'ZondaChecklists',
  storeName: 'offline_queue'
});

export const saveChecklistOffline = async (payload, photosBlobs, firmaBlob) => {
  try {
    const queue = await localforage.getItem('sync_queue') || [];
    
    // We store the blobs natively in localforage (IndexedDB supports formatting Blobs)
    queue.push({
      id: Date.now(),
      endpoint: "checklists/guardar",
      payload,
      photosBlobs,
      firmaBlob,
      timestamp: new Date().toISOString()
    });
    
    await localforage.setItem('sync_queue', queue);
    window.dispatchEvent(new Event('offline-queue-changed'));
    return true;
  } catch (err) {
    console.error('Error saving to localforage', err);
    return false;
  }
};

export const getPendingChecklists = async () => {
    return (await localforage.getItem('sync_queue')) || [];
};

export const syncChecklistsToServer = async () => {
  if (!navigator.onLine) return false;

  const queue = await getPendingChecklists();
  if (queue.length === 0) return true;

  let remainingQueue = [...queue];
  let hasErrors = false;

  console.log("Comenzando sincronización de", queue.length, "checklists pendientes...");

  for (const item of queue) {
    try {
      console.log("Sincronizando checklist ID:", item.id);
      
      let finalFirmaPayload = { ...item.payload.FirmaChecklists };
      let finalArchivosPayload = { ...item.payload.ChecklistsArchivos };

      // 1. Si hay firma pendiente, subirla a Firebase primero
      if (item.firmaBlob) {
        const folder = "Archivos";
        const ranm = Math.floor(Math.random() * 1000);
        const nombreFirebase = "Checklist_Firma_" + finalFirmaPayload.nombre + "_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + "_" + ranm;
        
        let url = await FirebaseStorage.upload(folder + "/" + nombreFirebase, item.firmaBlob);
        finalFirmaPayload.archivo = {
          nombreFirebase,
          folder,
          tipo: item.firmaBlob.type,
          url,
          nombre: nombreFirebase
        };
      }

      // 2. Si hay fotos pendientes, subirlas
      // photosBlobs es un array de { idApp, blob } u otro formato.
      // Aquí el modelo original esperaba un array the URLs o de objetos Archivo.
      // Como react-zonda usa Firebase para cada evidencia, vamos a emularlo.
      // Ojo: En detail.js original subía la evidencia desde "ChecklistArchivos", así que la subida ya la hacía FirebaseStorage.
      // Adaptaremos esta sección para subir cualquier archivo pendiente
      if (item.photosBlobs && item.photosBlobs.length > 0) {
          const folder = "Archivos";
          let archivosParaCheck = [];
          
          for (let photo of item.photosBlobs) {
             const ranm = Math.floor(Math.random() * 1000);
             const economico = item.payload.datosChecklists?.idCarro || 'Offline';
             const nombreFirebase = "Checklist_Evidencia_" + economico + "_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + "_" + ranm;
             
             let url = await FirebaseStorage.upload(folder + "/" + nombreFirebase, photo.blob);
             archivosParaCheck.push({
               nombreFirebase,
               folder,
               tipo: photo.blob.type,
               url,
               nombre: nombreFirebase
             });
          }
          finalArchivosPayload = archivosParaCheck;
      }

      // 3. Preparar el body final
      item.payload.FirmaChecklists = finalFirmaPayload;
      // Esto reemplaza "Archivos" con la información ya con URLs
      if (finalArchivosPayload.length > 0 || (Array.isArray(finalArchivosPayload) && finalArchivosPayload.length > 0)) {
          item.payload.ChecklistsArchivos = finalArchivosPayload;
      }

      // 4. Enviar a Yii2 usando Servo (usaremos fetch manual para no cambiar history/redirects)
      const token = await Servo.getCurrentToken?.() || ""; // Intentaremos importar la lógica del token si es pública, si no usamos Servo.post
      
      // En vez de fetch manual, mejor delegamos al propio Servo pero dummy parameters para history
      let resJson = await Servo.post(
          item.endpoint,
          item.payload,
          "checklists", // redirectUrl dummy
          false,        // redirectOnSave = false, para que no haga push en background!
          null,         // history = null
          true          // withToken
      );

      if (resJson?.cuerpo?.detalle?.estatus == 200 || resJson?.cuerpo?.resultado) {
        remainingQueue = remainingQueue.filter(q => q.id !== item.id);
        console.log("Sincronizado checklist local con éxito.");
      } else {
        hasErrors = true;
      }
    } catch (e) {
      console.error('Failed to sync checklist offline item', item.id, e);
      hasErrors = true;
    }
  }

  // Actualizar queue
  await localforage.setItem('sync_queue', remainingQueue);
  window.dispatchEvent(new Event('offline-queue-changed'));
  
  return !hasErrors;
};
